<template>
  <div class="w-100 h-100 d-flex flex-column position-relative" ref="ScrollRef" style="overflow-y: scroll;">

    <div v-if="!this.$store.state.isShareCodeDraft">
      <div class="row my-2">
        <div class="col">
          <div class="menu-tab-text menu-select-color">データ入稿</div>
        </div>
      </div>

      <div class="row p-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 1}">
        <div class="row text-start m-0">
          <p class="m-0 p-0">デザイン（PNG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickPngHelp()" /></p>
        </div>
        <label class="uploadlabel position-relative"
          ><input
            type="file"
            ref="design"
            accept=".png"
            @change="uploadDesign"
          />
          <div v-if="!isUploadDesign">
            <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
            <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
            <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
            </svg>
            <span class="fw-bold">アップロード</span>
          </div>
          <div v-else>
            <span class="text-main-color">{{this.getDesignFileName()}}</span>
          </div>
        </label>
      </div>

      <div class="row p-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 2}">
        <div class="row text-start m-0">
          <p class="m-0 p-0">カットライン（SVG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickSvgHelp()" /></p>
        </div>
        <label class="uploadlabel position-relative"
          ><input
            type="file"
            ref="cutline"
            accept=".svg"
            @change="uploadCutline"
          />
          <div v-if="!isUploadCutline">
            <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
            <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
            <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
            </svg>
            <span class="fw-bold">アップロード</span>
          </div>
          <div v-else>
            <span class="text-main-color">{{this.getCutlineFileName()}}</span>
          </div>
        </label>
      </div>

      <hr class="mt-1 mb-0">
    </div>

    <div class="row my-1">
      <div class="col m-0">
        <div class="menu-tab-text menu-select-color m-0">サンプル価格（送料込み）</div>
      </div>
    </div>

    <!-- 境界線 -->
    <p class="fw-bold m-1 text-end mb-0" style="">{{totalPrice}}円</p>
    <hr class="m-0">

    <!-- <p class="m-1 text-start" style="font-size: 15px;">( 1枚単価 <span class="status-error-color">{{discountText}}</span> )</p>
    <p class="fw-bold m-1 text-end mb-0" style="">{{price}}円</p>
    <hr class="m-0"> -->

    <div class="row my-1">
      <div class="col m-0">
        <div class="menu-tab-text menu-select-color m-0">数量（複数購入不可）</div>
      </div>
    </div>

    <div class="m-1 mb-1 text-end d-flex justify-content-end" style="">
      <span class="fw-bold">{{acrylNum}}</span>
      <!-- <input type="number" min="1" max="1" v-model="acrylNum" @blur="numBlur" class="forminput text-end no-spin pe-2" /> -->
    </div>
    <hr class="m-0">

    <span class="mt-1">配送先選択</span>

    <div class="row m-0 mb-3">
      <div class="col text-start">
        <p class="my-0 fw-bold mt-2">配送先</p>
        <select
          class="form-select"
          name="destination_list"
          id="destination_list"
          v-model="selectedDestination"
        >
          <option disabled value="default">選択してください</option>
          <option
            v-for="(d, index) in this.destinationList"
            v-bind:key="index"
            v-bind:value="index"
          >
            <small>配送先{{ index }}: 〒{{ d.zip01 }}-{{ d.zip02 }}</small>
          </option>
        </select>
        <button
          @click="onClickEditDestination"
          class="acry-btn-secondary-normal btn-size mt-3 mx-auto d-block" style=""
        >
          配送先を編集・追加
        </button>
        <template v-if="this.destinationList[this.selectedDestination]">
          <p class="my-0 mt-2 small">会社名</p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].company_name }}
          </p>
          <hr class="my-0" />
          <p class="my-0 small">部署名</p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].department_name }}&nbsp;
          </p>
          <hr class="my-0" />
          <p class="my-0 small">氏名</p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].name01 }}
            {{ this.destinationList[this.selectedDestination].name02 }}
          </p>
          <hr class="my-0" />
          <p class="my-0 small">電話番号</p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].tel01 }}-{{
              this.destinationList[this.selectedDestination].tel02
            }}-{{ this.destinationList[this.selectedDestination].tel03 }}
          </p>
          <hr class="my-0" />
          <p class="my-0 small">住所</p>
          <p class="text-end my-0 p-0 small">
            〒{{ this.destinationList[this.selectedDestination].zip01 }}-{{
              this.destinationList[this.selectedDestination].zip02
            }}
          </p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].addr01 }}
          </p>
          <p class="text-end my-0 p-0 small">
            {{ this.destinationList[this.selectedDestination].addr02 }}
          </p>
          <hr class="mt-0" />
        </template>
      </div>
    </div>

    <div class="mt-auto w-100 my-3 position-relative" :class="{'disable-ui':!(isUploadDesign&&isUploadCutline) && !this.$store.state.tutorial.isShowPreview}">
      <!-- <div class="position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 3}">
        <button @click="clickEdit" class="acry-btn-secondary-normal btn-size my-2 text-nowrap" >テキスト・二次元コードを入れる</button>
      </div>
      <div>
        <button @click="clickCart" class="acry-btn-cartin btn-size my-1" >カートに入れる</button>
      </div> -->
      <div class="row m-0 mt-2" @click="onClickEstimates">
        <div class="col p-0">
          <button class="acry-btn-secondary-normal btn-size">見積書発行</button>
        </div>
      </div>

      <div>
        <button @click="onClickOrder" class="acry-btn-cartin btn-size my-1" >注文する</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetCanvasSize,
  CenterViewState,
  // RightViewState,
  PreviewColorList,
  GetAcryProductPrice,
  PaymentType,
} from "@/js/Const.js";
import { CreateImageElement, CreateFrameCutlineImage, CreateSampleDesignImage, DiscountRatio, CombineSVGFrame } from "@/js/CommonFunc.js";
import { OffScreen } from "@/js/OffScreen.js";
import { ProductData } from "@/js/ProductData.js";
import VueCookies from "vue-cookies";
import { Big } from 'big.js';
import { User } from "@/js/User.js";
// import { ProductId } from "@/js/Const.js";
import { Common } from "@/js/common.js";
// import { DiscountRatio, DelivPrice } from "@/js/CommonFunc.js";
import { Analytics } from "@/js/Analytics.js";


export default {
  name: "RightMenuSamplePreview_Ap",
  props: {},
  data: function () {
    return {
      designFileName:"デザインデータ",
      cutlineFileName:"カットラインデータ",
      acrylNum: 1,
      price: 0,       // 割引後の1枚あたりの金額
      discountText: "",
      totalPrice: 0,  // 合計金額（税別）
      // 配送先
      destinationList: [],
      selectedDestination: "default", // 選択した配送先情報

    };
  },
  watch: {
  },
  computed: {
    isUploadDesign() {
      return this.$store.state.designImageURL != null;
    },
    isUploadCutline() {
      return this.$store.state.commonPreviewData.frameCutlineImageURL != null;
    },
  },
  async created() {
    this.$store.commit("setIsFirstTutorial", false);
    // 販売中のプロダクト情報を取得
    this.$store.commit("showRightMenu");
    this.$store.commit("showLoading");
    await this.$store.state.saleProductManager.update().catch((e) => {
      this.$common.log(e);
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
      this.$store.commit("hideLoading");
      return;
    });

    if (
      this.$store.state.saleProductManager.getProduct(
        this.$store.state.selectProductId
      ) == null
    ) {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "現在販売されていない商品です");
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      return;
    }

    this.selectProductData = this.$store.state.saleProductManager.getProduct(
      this.$store.state.selectProductId
    );

    this.updatePriceText();

    if (this.$store.state.scCutlineImageURL) {
      // シェアコード入稿の場合はカットラインを調整する
      console.log("createScFrameCutlineImage");
      await this.createScFrameCutlineImage();
    }

    this.$store.commit("hideLoading");

    if( this.$store.state.isShareCodeDraft ){
      // シェアコード入稿
      // SVGチュートリアルをすでに見ている場合は無視
      // let isTutorial = VueCookies.get("t_sp_s") || VueCookies.get("t_p_s");
      // if( !isTutorial ){
      //   this.isFirstTutorial = true;

      //   VueCookies.set("t_sp_s", true);

      //   // チュートリアル開始
      //   this.$store.commit("showPreviewTutorial", 3);
      // }
    }else{
      // SVG入稿
      let isTutorial = VueCookies.get("t_p_s");
      if( !isTutorial ){
        this.$store.commit("setIsFirstTutorial", true);

        VueCookies.set("t_p_s", true, '1y');

        // チュートリアル開始
        this.$store.commit("showPreviewTutorial");
      }
    }

    this.destinationList = await User.getDestinationList().catch((e) => {
      this.$common.log(e);
      this.$store.commit("hideLoading");
      this.tabAction(1);
      this.$store.commit("showMessage", "エラーが発生しました");
    });
  },
  components: {},
  methods: {
    numBlur(){
      if( isNaN(this.acrylNum) ) this.acrylNum = 1;
      if( this.acrylNum < 1 ) this.acrylNum = 1;
      if( this.acrylNum > 1 ) this.acrylNum = 1;
      this.updatePriceText();
    },
    getDesignFileName(){
      return this.designFileName;
    },
    getCutlineFileName(){
      return this.cutlineFileName;
    },
    async uploadDesign() {
      const file = this.$refs.design.files[0];
      this.designFileName = file.name;

      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      let offScreen = new OffScreen(canvasSize.width, canvasSize.height);
      let image = await CreateImageElement(URL.createObjectURL(file));
      offScreen.drawImage(image, 0, 0, image.width, image.height);
      let blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      // 追加でサンプル
      blob = await CreateSampleDesignImage(URL.createObjectURL(blob), canvasSize.width, canvasSize.height, this.$store.state.selectProductId);

      this.$store.commit("setDesignImageFile", blob);
      this.$store.commit("setDesignImageURL", URL.createObjectURL(blob));
      this.$store.commit("setCommonDesignImageURL", URL.createObjectURL(blob));
    },
    async uploadCutline() {
      let file = this.$refs.cutline.files[0];

      // フレームパスを合成
      file = await CombineSVGFrame(file, this.selectProductData.productId);

      this.cutlineFileName = file.name;
      this.$store.commit("setCutlineImageFile", file);
      this.$store.commit("setCutlineImageURL", URL.createObjectURL(file));

      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      let image = await CreateImageElement(this.$store.state.cutlineImageURL);
      offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      offScreen.replacement(PreviewColorList[this.$store.state.commonPreviewData.selectCutlineColor])

      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      this.$store.commit("setFrameCutlineImageFile", blob);
      this.$store.commit("setFrameCutlineImageURL", URL.createObjectURL(blob));
      this.$store.commit("setCommonFrameCutlineImageURL", URL.createObjectURL(blob));
    },
    updatePriceText(){
      // 数量変更される
      if( this.acrylNum == 0 ){
        this.totalPrice = this.price = 0;
        this.discountText = "";
      }else{
        let productPrice = GetAcryProductPrice(this.selectProductData.productId);
        let ratio = DiscountRatio(this.acrylNum );

        if( ratio == 0 ){
          this.discountText = "";
        }else{
          this.discountText = ratio + "%割引適応";
        }

        // 丸め誤差が出ないようにライブラリを使用して計算
        let priceBaseTotal = new Big(this.acrylNum * productPrice.priceBase); // 税抜き価格の合計
        let priceRatio = new Big(100-ratio).div(100);
        let totalPrice = priceBaseTotal.times(priceRatio);
        this.totalPrice = Math.floor(totalPrice.toNumber());
        this.price = Math.floor(this.totalPrice / this.acrylNum);
      }
    },

    onClickEditDestination() {
      this.$store.commit("switchShowCart");
      this.$store.commit("setShippingScreenType", "List");
      this.$store.commit("setCenterViewState", CenterViewState.Shipping);
    },

    async onClickEstimates() {
      // if (this.selectedDestination == "default") {
      //   this.$store.commit("showMessage", "配送先を設定してください");
      //   return;
      // }

      this.$store.commit("showProgress", true);

      this.$store.commit("setProgressMessages", [
        "見積もりデータ保存中…",
        "しばらくお待ちください",
      ]);

      // await this.$store.state.saleProductManager.update().catch((e) => {
      //   this.$common.log(e);
      //   this.$store.commit("hideLoading");
      //   this.$store.commit("showMessage", "エラーが発生しました");
      // });

      // データを作成
      await this.createProduct();

      let priceData = this.createProductPriceData();

      this.$store.commit("setEstimatesProductData", priceData.productList);

      this.$store.commit("hideProgress");

      // 配送先情報を設定
      let estimatesData = this.destinationList[this.selectedDestination];
      priceData.productList[0].totalPrice = priceData.totalPrice;
      priceData.productList[0].delivPrice = priceData.delivPrice;
      priceData.productList[0].productPrice = priceData.productPrice;
      priceData.productList[0].taxPrice = priceData.taxPrice;
      priceData.productList[0].discount = priceData.discount;
      estimatesData.issueDate = this.$common.getDateStringFromDate(new Date());

      this.$store.commit("showEstimates", estimatesData);
    },

    async editProcess(){
      // this.$store.commit("showLoading");
      // // 開始時に空白のテキストを追加しておく
      // // this.$store.state.currentCanvasData.addTextItem(
      // //   Array.from({ length: this.acrylNum }, () => ""),
      // //   "AnitoStd-M",
      // //   "center",
      // //   "#000000",
      // //   "TextItem_1"
      // // );
      // // this.$store.state.currentCanvasData.addQRItem(
      // //   Array.from({ length: this.acrylNum }, () => ""),
      // //   "#000000",
      // //   "#FFFFFF",
      // //   "CodeItem_1"
      // // );

      // this.$store.commit("hideLoading");
      // this.$store.commit("setCenterViewState", CenterViewState.Edit);
      // this.$store.commit("setRightViewState", RightViewState.Edit);
    },

    async createScFrameCutlineImage() {
      let canvasSize = GetCanvasSize(this.$store.state.selectProductId);
      let blob = await CreateFrameCutlineImage(this.$store.state.scCutlineImageURL, canvasSize.width, canvasSize.height);
      this.$store.commit("setFrameCutlineImageURL", URL.createObjectURL(blob));
      this.$store.commit("setFrameCutlineImageFile", blob);

      // 色も設定する
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      let image = await CreateImageElement(this.$store.state.frameCutlineImageURL);
      offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      offScreen.replacement(PreviewColorList[this.$store.state.commonPreviewData.selectCutlineColor])

      const blob2 = await new Promise((resolve) => {
        offScreen.toBlob(function (blob2) {
          resolve(blob2);
        });
      });

      // this.$store.commit("setFrameCutlineImageURL", URL.createObjectURL(blob2));
      this.$store.commit("setCommonFrameCutlineImageURL", URL.createObjectURL(blob2));
    },

    async onClickOrder() {
      if (this.selectedDestination == "default") {
        this.$store.commit("showMessage", "配送先を設定してください");
        return;
      }

      if (!this.$store.state.isSignature) {
        this.$store.commit("showResendContractDialog");
        //this.$store.commit("showMessage", "契約書へのサインが完了していません");
        return;
      }

      // データを作成
      await this.createProduct();

      await this.orderProcess();
    },

    async orderProcess(bikou = "") {
      //this.$store.commit("showLoading");

      this.$store.commit("showProgress", true);
      this.$store.commit("setProgress", 0);
      this.$store.commit("setSendBytes", 0);

      this.$store.commit("setProgressMessages", [
        "デザイン送信中…",
        "しばらくお待ちください",
      ]);

      // await this.$store.state.saleProductManager.update().catch((e) => {
      //   this.$common.log(e);
      //   //this.$store.commit("hideLoading");
      //   this.$store.commit("hideProgress");
      //   this.$store.commit("showMessage", "エラーが発生しました");
      // });

      // 一応金額を再計算
      //this.updatePayment();

      // await this.$store.state.optionManager.update().catch((e) => {
      //   this.$common.log(e);
      //   this.$store.commit("hideLoading");
      //   this.$store.commit("showMessage", "エラーが発生しました");
      // });

      let productData = []; // API送信時に使用
      let marginTotal = 0;
      let marginTotalIncTax = 0;
      //let priceTotal = 0;
      //let taxTotal = 0;

      let progressPlus = (95 / this.$store.state.products.length).toFixed();
      let prog = 0;
      //let totalSendBytes = 0;

      let sampleProducts = [];  // 注文履歴用データ
      let quantityTotal = 0; // 注文時間の推測に使用

      // 受注用のデータを並列処理
      //acrylProducts = await this.createProductData();

      // プロダクト分ループ
      {
        let p = this.$store.state.currentProduct;
        sampleProducts.push(p);
        let firstProg = prog;

        // 事前に生成していない場合のみ
        // データをアップロード
        // この関数でZIPデータ保存、デザイン画像保存が一気にできる
        await this.$store.state.currentProduct.uploadDesignData(()=>{});


        for (let i = 0; i < p.quantity; ++i) {
          console.log("getProductData" + i);

          prog = firstProg + progressPlus * 0.8;
          //this.$store.commit("setProgress", prog.toFixed());
          let pdata = await p.getProductItemData(i);
          prog += progressPlus * 0.2;
          //this.$store.commit("setProgress", prog.toFixed());

          marginTotal += Number(pdata.margin);
          marginTotalIncTax += Number(pdata.margin_inctax);
          //priceTotal += Number(pdata.price_inctax);
          //priceTotal += Number(pdata.price_inctax);
          //taxTotal += pdata.tax;

          productData.push(pdata);
        }

        quantityTotal += parseInt(p.quantity);
      }

      quantityTotal += parseInt(this.$store.state.cartManager.cartList.length);

      this.$store.commit("setProgress", 3);

      console.log("updatePayment");
      //this.updatePayment();
      let priceData = this.createProductPriceData();
      console.log(priceData);

      let delivTax = Math.ceil(priceData.delivPrice * this.$common.getTax());

      let data = {
        deliv_check: this.destinationList[this.selectedDestination].other_deliv_id,
        fee_base: "0",
        fee_tax_rate: "0",
        fee_tax: "0",
        fee: "0",
        // 送料(税抜き)
        deliv_fee_base: priceData.delivPrice,
        // 送料税率
        deliv_fee_tax_rate: (this.$common.getTax() * 100).toFixed(),
        // 送料税額
        deliv_fee_tax: delivTax,
        // 送料税込
        deliv_fee: priceData.delivPrice + delivTax,
        // マージン率
        margin_rate: User.userData.introduced_margin,
        // マージン額合計(税抜き)
        margin_total: marginTotal,
        // マージン額合計(税込み)
        margin_total_inctax: marginTotalIncTax,
        // 商品代金税込マージン込み
        subtotal:
          priceData.productPrice +
          Math.ceil(priceData.productPrice * this.$common.getTax()),
        // 合計税額 送料分の税額は省く
        tax: priceData.taxPrice - delivTax,
        payment_total: priceData.totalPrice,
        discount: priceData.discount,
        message: bikou ? bikou : "",
      };
      this.$common.log(data);

      this.$store.commit("setProgress", 3);

      const TotalTime = 0.34 * quantityTotal;
      let oneSecondProgress = (99 - 3) / TotalTime;
      let progress = 3.0;

      // console.log(quantityTotal);
      // console.log(TotalTime);
      // console.log(oneSecondProgress);

      let timer = setInterval(
        function () {
          progress += oneSecondProgress;

          if (99 < parseInt(progress)) {
            this.$store.commit("setProgress", 99);
          } else {
            this.$store.commit("setProgress", parseInt(progress));
          }
        }.bind(this),
        1000
      );

      // 注文APIを実行
      User.orderProduct(productData, data, PaymentType.CREDIT)
        .then((result) => {
          clearInterval(timer);

          // 注文履歴に登録
          // firestore
          this.$store.state.orderHistoryManager
            .registOrderHistoryData([], [], sampleProducts, result.order_id)
            .then(() => {
              // 注文完了
              this.$store.commit("setProgress", 100);
              //this.$store.commit("hideLoading");
              this.$store.commit("hideProgress");
              result.payment_total = data.payment_total;
              this.$store.commit("showBankData", result);
              //this.$store.commit("resetCart");
              this.isCheckTerms = false;
              //this.resetCart();

              // カード決済
              this.$store.commit("showCardPayment", {
                price: priceData.totalPrice,
                orderId: result.order_id,
              });

              // 決済完了後の処理を登録
              this.$store.commit("setCardPaymentCallback", ()=>{
                Analytics.purchase(result.order_id, data, productData);
                this.$store.commit("setCenterViewState", CenterViewState.SampleUpload);
              });
            })
            .catch(() => {
              this.$store.commit("hideProgress");
              this.$store.commit("showMessage", "エラーが発生しました");
            });
        })
        .catch((error) => {
          clearInterval(timer);
          this.$common.log(error);
          this.$store.commit("hideProgress");
          this.$store.commit("showMessage", "エラーが発生しました");
        });
    },

    async createProduct() {
      let p = new ProductData(
        this.selectProductData,
        this.selectProductData.productData["product_class_list2"][0]
      );

      p.quantity = this.acrylNum;
      p.tagInfo = "noTag";
      console.log(this.tagInfo);
      console.log(this.printInfo);
      p.setPrintInfo("front");
      p.tagTemplateName = "";
      p.whiteCount = 0;
      p.isShareCodeDraft = this.$store.state.isShareCodeDraft;

      this.$store.commit("addProduct", p);
      this.$store.commit("hideModal");
      this.$store.commit("selectCanvasData", p.canvasDatas[0]);

      await this.$store.state.currentCanvasData.setBaseImage(
        this.$store.state.designImageFile,
        this.$store.state.designImageURL,
        (this.$store.state.isShareCodeDraft)?this.$store.state.scCutlineImageFile:this.$store.state.cutlineImageFile,
        this.$store.state.commonPreviewData.frameCutlineImageURL
      );
    },

    // カート内の商品価格の計算を行う
    createProductPriceData() {
      let productPriceData = {};
      productPriceData.productList = [];
      productPriceData.totalPrice = 0; // 払うべき金額 送料 + 商品合計 + 消費税合計 - 割引額
      productPriceData.delivPrice = 0; // 送料 (税別)
      productPriceData.productPrice = 0; // 商品合計 (税別)
      productPriceData.taxPrice = 0; // 消費税合計
      productPriceData.discount = 0; // アクリル商品の割引額 (税込)

      let p = this.$store.state.currentProduct;

      let product = {};
      product.title = p.getProductTitle();
      product.price = p.getOnePrice();
      product.tax = p.getOnePrice() * Common.getTax();
      product.quantity = this.acrylNum;
      product.discount = 0;
      product.getProductTitle = function () {
        return "title";
      };
      productPriceData.productList.push(product);

      productPriceData.productPrice += product.price * product.quantity;
      productPriceData.taxPrice += product.tax * product.quantity;
      productPriceData.discount += product.discount;
      productPriceData.totalPrice += (product.price + product.tax) * product.quantity;

      // 送料計算
      productPriceData.delivPrice = 0;
      productPriceData.taxPrice += productPriceData.delivPrice * Common.getTax();
      productPriceData.totalPrice += productPriceData.delivPrice * (Common.getTax() + 1);

      // 割引分を引く
      productPriceData.totalPrice -= productPriceData.discount;

      // 最終金額
      productPriceData.taxPrice = Math.floor(productPriceData.taxPrice);
      productPriceData.totalPrice = Math.floor(productPriceData.totalPrice);

      return productPriceData;
    },

    tutorialNextStep(){
      if( this.$store.state.tutorial.isFirst ){
        // 初回は強制で全て表示
        if(this.$store.state.tutorial.previewStep == 2){
          this.$store.commit("hidePreviewTutorial");
          this.$store.commit("setIsFirstTutorial", false);
        }else{
          this.$store.commit("previewTutorialNextStep");
        }
      }else{
        // 2回目以降は一部分のみ表示
          this.$store.commit("hidePreviewTutorial");
      }
    },
    clickPngHelp(){
      this.$store.commit("setPreviewTutorialScroll", this.$refs.ScrollRef.scrollTop);
      this.$store.commit("showPreviewTutorial", 1);
    },
    clickSvgHelp(){
      this.$store.commit("setPreviewTutorialScroll", this.$refs.ScrollRef.scrollTop);
      this.$store.commit("showPreviewTutorial", 2);
    },

  },
};
</script>

<style scoped lang="scss">
.uploadlabel {
  margin: 8px;
  padding: 8px;
  cursor: pointer;
  font-size: 15px;
  width: 267px;
  height: 40px;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 100px;
  background: $background-white-color;
}

.fill-color {
  fill: $primary-main-color;
  position: absolute;
  left: 51px;
  top: 6px;
}

input[type="file"] {
  display: none;
}

.btn-size{
  width: 100%;
  height: 40px;
  font-weight: bold;
}
.form{
  height: 48px;

}

.forminput {
  width: 100%;
  border: 1px solid $status-success-color;
}

.disable-ui {
  opacity: 0.5;
}

.feature-ui{
  z-index: 3;
  pointer-events: none;
  background: white;
}

.tutorial-modal{
  width: 850px;
  position: absolute;
  left: -880px;
  z-index: 3;
  background: white;
  border-radius: 4px;
}

.outline-btn {
  width: 250px;
  height: 40px;
  border: 3px solid $primary-main-color;
  color: $primary-main-color;
  border-radius: 20px;
  margin-top: 1px;
  background-color: white;
  font-weight: bold;
}
</style>
